import React from "react"
import BackgroundImage from "gatsby-background-image"
import Header from "./header"
import DataAbout from "./data-about"
import DataCompetencies from "./data-competencies"
import DataServices from "./data-services"
//import { render } from "react-dom"

const Content = ({
  slide,
  title,
  imageData,
  description,
  photo,
  tag,
  theme,
}) => {
  const renderSwitch = ({ tag, slide }) => {
    switch (tag) {
      case "about":
        return <DataAbout tag={tag} slide={slide} />

      case "leistungen":
        return <DataServices tag={tag} slide={slide} />

      case "kompetenzen":
        return <DataCompetencies tag={tag} slide={slide} />

      default:
        return []
    }
  }

  return (
    <>
      <section className="hero is-customheight is-bold">
        <Header
          siteTitle="Klaus Architekten Innenarchitekten AG"
          theme={theme}
        />

        <BackgroundImage fluid={imageData} fadeIn className="background-img" />

        <div className="colums is-left has-gradient-bottom">
          <div className="column is-two-thirds left-align pb-6 px-5">
            <h1 className="title is-size-1-desktop is-size-4-touch has-text-white">
              {title}
            </h1>

            {description.split("/n").map((item, key) => (
              <p
                className="is-size-5-desktop is-size-6-tablet is-size-7-mobile"
                key={key}
              >
                {item}
              </p>
            ))}

            {!!photo ? (
              <span className="is-size-6-desktop is-size-7-touch has-text-grey-light">
                <b>Foto:</b> {photo}
              </span>
            ) : (
              ""
            )}
          </div>
        </div>
      </section>
      <section className="section is-marginless is-paddingless">
        {renderSwitch({ tag, slide })}
      </section>
    </>
  )
}

export default Content
